// @ngInject
function DeliveryTermsApiService(ResourcesService) {

  var endpoint = 'deliveryterms';

  return {
    getDeliveryTerms: ResourcesService.apiFactory.get(endpoint),
    getDeliveryTerm: ResourcesService.apiFactory.get(endpoint),
    getLanguages: ResourcesService.apiFactory.get(endpoint + '/languages'),
    createDeliveryTerm: ResourcesService.apiFactory.create(endpoint, 'DeliveryTerm'),
    updateDeliveryTerm: ResourcesService.apiFactory.update(endpoint, 'DeliveryTerm'),
    deleteDeliveryTerm: ResourcesService.apiFactory.delete(endpoint, 'DeliveryTerm')
  };

}

angular
  .module('deliveryterms.api', [])
  .factory('DeliveryTermsApiService', DeliveryTermsApiService);
